import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle, HandHelping } from "lucide-react";
import { useLang } from "@/i18n";
import { track, waLink } from "@/lib/api";

export default function MobileBar() {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <div
      data-testid="mobile-bottom-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-[#121316]/96 backdrop-blur-lg border-t border-white/10 flex items-center gap-3"
    >
      <button
        data-testid="mobile-book-btn"
        onClick={() => { track("book_click", { source: "mobile_bar" }); navigate("/book"); }}
        className="flex-1 h-12 rounded-full btn-saffron font-bold text-sm inline-flex items-center justify-center gap-2"
      >
        <HandHelping size={18} /> {t("book")}
      </button>
      <button
        data-testid="mobile-whatsapp-btn"
        onClick={() => { track("whatsapp_click", { source: "mobile_bar" }); window.open(waLink("Hi CHELA! I'd like to book an extra pair of hands."), "_blank"); }}
        className="h-12 w-12 rounded-full btn-whatsapp inline-flex items-center justify-center"
        aria-label="WhatsApp"
      >
        <MessageCircle size={20} />
      </button>
    </div>
  );
}
